export default __webpack_public_path__ + "static/media/noa-22.5862ef57.jpg";